import React from "react";
import { Container } from "react-bootstrap";
import "../../incidentes.css";
import useVideoModal from "./useVideoModal";
import VideoModal from "./VideoModal";
import useProgresoVideos from "./useProgresoVideos";
import ProgresoResumen from "./ProgresoResumen";
import videoBaseURL from "./videoBaseURL";

const DeepLearning = () => {
  const { show, videoActivo, handleShow, handleClose } = useVideoModal();
  const { estaVisto, marcarVisto } = useProgresoVideos();

  // Estructura simplificada de los 4 videos
  const videos = [
    {
      nombre: "Video 1: ¿Por qué Deep Learning? (Más allá del ML Clásico)",
      url: `${videoBaseURL}DL1.mp4`,
      conceptoclave: [
        'La diferencia entre ML Clásico y Deep Learning.',
      ],
      termino: [
        'Analogía (Ingeniería): El problema de la "Ingeniería de Características" (Feature Engineering) manual vs. la automática.'
      ]
    },
    {
      nombre: 'Video 2: ¿Qué es una Red Neuronal? El "Cerebro" de la IAA',
      url: `${videoBaseURL}DL2.mp4`,
      conceptoclave: [
        'El bloque de construcción: la neurona (perceptrón) y las capas.',
      ],
      termino: [
        'Analogía (Ingeniería): Una red neuronal como una cadena de procesamiento de señales (DSP) autoajustable.'
      ]
    },
    {
      nombre: 'Video 3: Redes Recurrentes (RNN/LSTM): La IA que entiende Secuencias',
      url: `${videoBaseURL}DL3.mp4`,
      conceptoclave: [
        'Modelos con "memoria" para analizar datos secuenciales.',
      ],
      termino: [
        'Aplicación (Observabilidad): Análisis de logs de series temporales y predicción de fallos.'
      ]
    },
    {
      nombre: "Video 4: Transformers y LLMs: La IA que entiende el Contexto",
      url: `${videoBaseURL}DL4.mp4`,
      conceptoclave: [
        'El mecanismo de "Atención" y los Modelos de Lenguaje Grandes (LLMs).',
      ],
      termino: [
        'Aplicación (Observabilidad): Resumir 10,000 logs en un solo párrafo (IA Generativa para AIOps).'
      ]
    },
    {
      nombre: "Video 5: Detección de Anomalías con Autoencoders",
      url: `${videoBaseURL}DL5.mp4`,
      conceptoclave: [
        'La arquitectura "compresor/descompresor" para aprender qué es "normal".',
      ],
      termino: [
        'Aplicación (Ciberseguridad): Detección de intrusos (NDR) y comportamiento anómalo de usuarios (UEBA).'
      ]
    },
    {
      nombre: "Video 6: Caso Práctico (AIOps): De 500 Alertas a 1 Causa Raíz",
      url: `${videoBaseURL}DL6.mp4`,
      conceptoclave: [
        'Unir un LLM (para logs) y un Autoencoder (para métricas) para resolver un incidente de "aplicación lenta".',
      ],
      termino: [
        'Caso práctico que unifica las aplicaciones de los videos anteriores para demostrar cómo AIOps utiliza múltiples modelos de Deep Learning en conjunto para resolver un problema real'
      ]
    },
  ];

  return (
    <>
      <Container fluid className="background-containerr">
        <div className="orgproc-header">
          <h1 className="orgproc-heading">Deep Learning para Ingenieros de ITOps</h1>
        </div>

        <ProgresoResumen vistos={videos.filter((v) => estaVisto(v.url)).length} total={videos.length} />

        <div className="orgproc-grid-3col">
          {videos.map((video, idx) => (
            <div className="orgproc-card" key={video.nombre}>
              <div className="orgproc-card-accent"></div>
              <div className="orgproc-card-body">
                <div className="orgproc-eyebrow">Video #{idx + 1}</div>
                {estaVisto(video.url) && <span className="orgproc-visto-badge">✓ Visto</span>}
                <div className="orgproc-card-title">{video.nombre}</div>

                <div className="orgproc-card-block">
                  <div className="orgproc-card-block-label">Concepto Clave</div>
                  <ul className="orgproc-card-list">
                    {video.conceptoclave.map((item, i) => (
                      <li key={i}>{item}</li>
                    ))}
                  </ul>
                </div>

                <div className="orgproc-card-block">
                  <div className="orgproc-card-block-label">Analogía / Aplicación</div>
                  <ul className="orgproc-card-list">
                    {video.termino.map((item, i) => (
                      <li key={i}>{item}</li>
                    ))}
                  </ul>
                </div>

                <div className="orgproc-card-actions">
                  <button
                    type="button"
                    className="orgproc-card-btn"
                    onClick={() => handleShow(video)}
                  >
                    {estaVisto(video.url) ? "Volver a ver →" : "Reproducir Video →"}
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </Container>

      <VideoModal show={show} video={videoActivo} onHide={handleClose} onPlay={marcarVisto} />
    </>
  );
};


export default DeepLearning;
